import { useMutation } from '@tanstack/react-query'

import { useIcaewModals } from '@/components/modals/IcaewModals/hooks/useIcaewModals'
import { useInvalidateCompanyConsentsQuery } from '@/hooks/useInvalidateCompanyConsentsQuery'
import useNotyf from '@/hooks/useNotyf'
import { useRefreshSessionMetadataMutation } from '@/hooks/useRefreshSessionMetadataMutation'
import { CONSENT_DECISION, CONSENT_TYPE } from '@/lib/constants'
import companyConsentService from '@/lib/services/companyConsentService'
import { ConsentDecisionType } from '@/types/misc'

export function useUpdateIcaewConsentMutation() {
  const notyf = useNotyf()
  const invalidateCompanyConsentsQuery = useInvalidateCompanyConsentsQuery()
  const refreshSessionMetadataMutation = useRefreshSessionMetadataMutation()
  const { recordStepCompletion } = useIcaewModals()

  return useMutation({
    mutationFn: (consentDecision: ConsentDecisionType) =>
      companyConsentService.updateCompanyConsent({
        consentType: CONSENT_TYPE.ICAEW,
        decision: consentDecision,
      }),
    onSuccess: async (_data, consentDecision) => {
      await refreshSessionMetadataMutation.mutateAsync()
      recordStepCompletion()

      await invalidateCompanyConsentsQuery()

      const message =
        consentDecision === CONSENT_DECISION.OPT_IN
          ? 'You have opted in. Your data will be shared with the ICAEW.'
          : 'You have opted out. Your data will not be shared with the ICAEW.'

      notyf.success(message)
    },
    onError: () => {
      notyf.error(
        'There was a problem processing your request. Please refresh the page and try again.',
      )
    },
  })
}
